<template>
  <div class="fqc-pc">
    <inspection-form ref="inspectionRef" @updateTable="getData" type="fqc"
      :closedLoopAuthority="false"></inspection-form>
    <a-space class="space">
      <a-date-picker v-model:value="requestPayload.localDate" placeholder="日期" allowClear
        @change="hanldeSelectDate"></a-date-picker>

      <a-range-picker v-model:value="rangePickerValue" @change="handleUpdateRange" />

      <a-input v-model:value="requestPayload.batchNumber" placeholder="生产批号" allowClear @change="searchData"></a-input>

      <a-select v-model:value="requestPayload.status" placeholder="状态" allowClear @change="searchData">
        <a-select-option value="未检">未检</a-select-option>
        <a-select-option value="合格">合格</a-select-option>
        <a-select-option value="不合格">不合格</a-select-option>
      </a-select>

      <a-cascader v-model:value="modelSpecifications" placeholder="型号规格" :options="modelSpecificationsOption" allowClear
        @change="handleSelectModel">
      </a-cascader>

      <a-input v-model:value="requestPayload.search" placeholder="搜索" allowClear @change="searchData"></a-input>
    </a-space>

    <div class="space">
      <a-table class="space" :data-source="table.data" bordered :pagination="false" :columns="columns" rowKey="id"
        :scroll="{ y: 'calc(100vh - 390px)', x: 'calc(100vw - 360px)' }">
        <template #status="{ record }">
          <a-tag :color="setColor(record.status)">{{ record.status }}</a-tag>
        </template>
        <template #reason1="{ record }">
          <div v-if="record.reason1">
            <div v-for="(item, index) in record.reason1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #reason2="{ record }">
          <div v-if="record.reason2">
            <div v-for="(item, index) in record.reason2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #solution1="{ record }">
          <div v-if="record.solution1">
            <div v-for="(item, index) in record.solution1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #solution2="{ record }">
          <div v-if="record.solution2">
            <div v-for="(item, index) in record.solution2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #question1="{ record }">
          <div v-for="(img, index) in record.issuesImg1" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in record.issuesVideo1" :key="index">
            <video :src="video" controls width="120" :key="video"></video>
          </div>
          <div v-for="(item, index) in record.issuesDesc1" :key="index">
            {{ item }}
          </div>
        </template>
        <template #question2="{ record }">
          <div v-for="(img, index) in record.issuesImg2" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in record.issuesVideo2" :key="index">
            <video :src="video" controls width="120" :key="video"></video>
          </div>
          <div v-for="(item, index) in record.issuesDesc2" :key="index">
            {{ item }}
          </div>
        </template>
        <template #questionType2="{ record }">
          <div v-if="record.questionType2">
            <div v-for="(item, index) in record.questionType2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #questionType1="{ record }">
          <div v-if="record.questionType1">
            <div v-for="(item, index) in record.questionType1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #action="{ record }">
          <a-dropdown>
            <template #overlay>
              <a-menu @click="handleMenuClick($event, record)">
                <a-menu-item key="成品信息" :disabled="!warehouseEditAuthority" >成品信息</a-menu-item>
                <a-menu-item key="质检问题" :disabled="record.status !== '不合格'">质检问题</a-menu-item>
              </a-menu>
            </template>
            <a-button size="small" type="primary">
              编辑
              <DownOutlined />
            </a-button>
          </a-dropdown>
        </template>
      </a-table>
    </div>

    <div class="pagination">
      <a-pagination size="small" :total="table.total" :show-total="(total) => `共 ${total} 条`"
        v-model:pageSize="table.lineNum" v-model:current="table.pageNum" @change="hanldeUpdatePageNum" />
    </div>
  </div>

  <fqc-form ref="fqcFormRef" @handleUpdateTable="handleUpdateTable"></fqc-form>
</template>

<script>
import { defineComponent, inject, ref, watch } from "vue";
import { Toast } from "@/utils";
import { defaultModel } from "@/views/productDaily/components/instruction/option";
import { useTable } from "@/views/notice/serve/table";
import { getFQCList } from "@/request/view/warehouse";
import { modelSpecificationsOption } from "@/views/productDaily/serve/option";
import fqcForm from "@/views/productDaily/warehouse/fqcForm.vue";
import { setmediaInfo } from "@/views/productDaily/warehouse/option";
import { DownOutlined } from "@ant-design/icons-vue";
import inspectionForm from "@/views/productDaily/components/product/components/qualityInspection/form.vue";

export default defineComponent({
  components: {
    fqcForm,
    inspectionForm,
    DownOutlined,
  },
  setup(props, context) {
    const warehouseEditAuthority = inject('warehouseEditAuthority', false);
    const fqcFormRef = ref();
    const inspectionRef = ref();
    const rangePickerValue = ref([]);
    const modelSpecifications = ref([]);
    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      deleteRecords,
      hanldeUpdatePageNum,
    } = useTable();

    requestConfig.pull_fn = getFQCList;

    initPayload({
      endDate: null,
      inspectionFrequency: null,
      localDate: null,
      modelSpecifications: null,
      produceOrTpc: inject('produceOrTpc', null),
      questionType: null,
      search: null,
      startDate: null,
      status: null,
      batchNumber: null,
    });

    const setColor = (status) => {
      let color = "";
      switch (status) {
        case "未检":
          color = "orange";
          break;
        case "不合格":
          color = "#f50";
          break;
        case "合格":
          color = "#87d068";
          break;
        default:
          break;
      }
      return color;
    };

    const handleUpdateFQC = (record) => {
      const type = "insert";

      const options = {
        title: "成品信息",
        data: record,
      };

      fqcFormRef.value.showModal(type, options);
    };

    const searchData = () => {
      table.pageNum = 1;
      getData();
    };

    const hanldeSelectDate = (e, stringTime) => {
      requestPayload.localDate = stringTime;

      if (stringTime) {
        requestPayload.startDate = null;
        requestPayload.endDate = null;
      }
      searchData();
    };

    const handleSelectModel = (e) => {
      const [project, model] = e;
      requestPayload.modelSpecifications = model;
      searchData();
    };

    const handleUpdateRange = (e, stringTime) => {
      const [startTime, endTime] = stringTime;
      if (startTime && endTime) {
        requestPayload.startDate = startTime;
        requestPayload.endDate = endTime;
        requestPayload.localDate = null;
        searchData();
        return;
      }

      requestPayload.startDate = null;
      requestPayload.endDate = null;
      searchData();
    };

    const getData = () => {
      getListData().then(() => {
        setmediaInfo(table.data);
      });
    };

    const columns = [
      {
        title: "机身号",
        dataIndex: "serial",
        align: "center",
        width: "200px",
        fixed: "left",
      },
      {
        title: "总装调试SN号",
        dataIndex: "assembleDebugsnNumber",
        align: "center",
        width: "210px",
      },
      {
        title: "生产批号",
        dataIndex: "batchNumber",
        align: "center",
        width: "140px",
      },
      {
        title: "状态",
        slots: {
          customRender: "status",
        },
        align: "center",
        width: "100px",
      },
      {
        title: "生产日期",
        dataIndex: "localDate",
        align: "center",
        width: "160px",
      },
      {
        title: "型号规格",
        dataIndex: "modelSpecifications",
        align: "center",
        width: "120px",
      },
      {
        title: "第1次送检问题",
        children: [
          {
            title: "问题",
            slots: { customRender: "question1" },
            align: "center",
            width: 260,
          },
          {
            title: "问题类型",
            slots: { customRender: "questionType1" },
            align: "center",
            width: 100,
          },

          {
            title: "送检人",
            dataIndex: "inspectionPersonnel1",
            width: 90,
            align: "center",
          },
          {
            title: "质检人",
            dataIndex: "qualityPersonnel1",
            width: 90,
            align: "center",
          },
          {
            title: "原因",
            dataIndex: "reason1",
            width: 90,
            align: "center",
          },
          {
            title: "解决方案",
            dataIndex: "solution1",
            width: 120,
            align: "center",
          },
        ],
      },
      {
        title: "第2次送检问题",
        children: [
          {
            title: "问题",
            slots: { customRender: "question2" },
            align: "center",
            width: 260,
          },
          {
            title: "问题类型",
            slots: { customRender: "questionType2" },
            align: "center",
            width: 100,
          },
          {
            title: "送检人",
            dataIndex: "inspectionPersonnel2",
            width: 90,
            align: "center",
          },
          {
            title: "质检人",
            dataIndex: "qualityPersonnel2",
            width: 90,
            align: "center",
          },
          {
            title: "原因",
            dataIndex: "reason2",
            width: 90,
            align: "center",
          },
          {
            title: "解决方案",
            dataIndex: "solution2",
            width: 120,
            align: "center",
          },
        ],
      },
      { title: "备注", dataIndex: "notes", align: "center", width: "100px" },
      {
        title: "操作",
        fixed: "right",
        slots: {
          customRender: "action",
        },
        align: "center",
        width: "140px",
      },
    ];

    const handleMenuClick = (e, record) => {
      const type = e.key;
      if (type === "成品信息") {
        handleUpdateFQC(record);
      } else if (type === "质检问题") {
        inspectionRef.value.openModal("editPQC", record);
      }
    };

    const activeKey = inject("activeKey", null);

    const handleUpdateTable = () => {
      getData()
    };

    watch(
      () => activeKey,
      (val) => {
        if (val && val.value === "fqc") {
          modelSpecifications.value.length = 0;
          requestPayload.endDate = null;
          requestPayload.inspectionFrequency = null;
          requestPayload.modelSpecifications = null;
          requestPayload.produceOrTpc = inject('produceOrTpc', null);
          requestPayload.questionType = null;
          requestPayload.search = null;
          requestPayload.startDate = null;
          requestPayload.status = null;
          table.pageNum = 1;
          getData();
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    return {
      table,
      columns,
      setColor,
      warehouseEditAuthority,
      fqcFormRef,
      defaultModel,
      inspectionRef,
      requestPayload,
      rangePickerValue,
      handleUpdateFQC,
      handleUpdateTable,
      hanldeSelectDate,
      handleUpdateRange,
      getData,
      hanldeUpdatePageNum,
      searchData,
      handleSelectModel,
      modelSpecifications,
      modelSpecificationsOption,
      handleMenuClick,
    };
  },
});
</script>

<style lang="less" scoped>
.fqc-pc {
  width: 100%;
  height: 100%;

  .space {
    margin-bottom: 10px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
